import { render, staticRenderFns } from "./buildAccount.vue?vue&type=template&id=5b5e0935&scoped=true&"
import script from "./buildAccount.vue?vue&type=script&lang=js&"
export * from "./buildAccount.vue?vue&type=script&lang=js&"
import style0 from "./buildAccount.vue?vue&type=style&index=0&id=5b5e0935&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5e0935",
  null
  
)

component.options.__file = "buildAccount.vue"
export default component.exports